module.exports = __webpack_public_path__ + "static/media/information-transparent-icon.4b9585cb.svg";